import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateSlugMutation = createMutationHook(ShopsApiClient.updateSlug, {
  mutationKey: ['updateSlug'],
})
